import Nav from 'react-bootstrap/Nav'
import NavLink from 'react-bootstrap/NavLink'
import Navbar from 'react-bootstrap/Navbar'
import NavbarToggle from 'react-bootstrap/NavbarToggle'
import Collapse from 'react-bootstrap/Collapse'
import { restoreDefaultProps, restoreFindDOMNode } from '.'

// Nav.Link renders `as` (from defaultProps); Navbar.Collapse animates with Collapse.
restoreDefaultProps(Nav, NavLink, Navbar, NavbarToggle, Collapse)
restoreFindDOMNode()
